export const OPEN_ENDED_VOTING__LOADING_ANIMATION_URL =
  'https://static.mentimeter.com/static/motion/open-ended-voting--loading.lottie';
